import React from 'react';

interface BadgeProps {
  variant?: 'success' | 'warning' | 'danger' | 'info' | 'neutral' | 'primary';
  size?: 'sm' | 'md';
  style?: 'solid' | 'soft' | 'outline';
  children: React.ReactNode;
  className?: string;
}

export const Badge: React.FC<BadgeProps> = ({
  variant = 'neutral',
  size = 'md',
  style = 'solid',
  children,
  className = '',
}) => {
  const baseStyles = 'inline-flex items-center font-medium rounded-full whitespace-nowrap';

  const sizeStyles = {
    sm: 'px-2 py-0.5 text-xs h-5',
    md: 'px-2.5 py-1 text-sm h-6',
  };

  const variantStyles = {
    solid: {
      success: 'bg-success-600 text-white',
      warning: 'bg-warning-500 text-white',
      danger: 'bg-danger-600 text-white',
      info: 'bg-info-600 text-white',
      neutral: 'bg-neutral-600 text-white',
      primary: 'bg-primary-600 text-white',
    },
    soft: {
      success: 'bg-success-100 text-success-700',
      warning: 'bg-warning-100 text-warning-700',
      danger: 'bg-danger-100 text-danger-700',
      info: 'bg-info-100 text-info-700',
      neutral: 'bg-neutral-100 text-neutral-700',
      primary: 'bg-primary-100 text-primary-700',
    },
    outline: {
      success: 'border border-success-600 text-success-700',
      warning: 'border border-warning-600 text-warning-700',
      danger: 'border border-danger-600 text-danger-700',
      info: 'border border-info-600 text-info-700',
      neutral: 'border border-neutral-600 text-neutral-700',
      primary: 'border border-primary-600 text-primary-700',
    },
  };

  return (
    <span
      className={`${baseStyles} ${sizeStyles[size]} ${variantStyles[style][variant]} ${className}`}
    >
      {children}
    </span>
  );
};
